import { fetchUser } from '@/routes/admin.tsx';
import { createFileRoute, redirect } from '@tanstack/react-router';
import Login from '../pages/auth/Login';

type SignInSearch = {
  error?: 'invalid_link';
};

export const Route = createFileRoute('/sign-in')({
  validateSearch: (search: Record<string, unknown>): SignInSearch => ({
    error: search.error === 'invalid_link' ? 'invalid_link' : undefined,
  }),
  beforeLoad: async () => {
    const user = await fetchUser();

    if (user) {
      throw redirect({ to: '/admin' });
    }

    return {
      user,
    }
  },
  component: Login,
});
